import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const activityItem = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    type: options([
      { value: 'Resource', name: 'Resource' },
      { value: 'Text', name: 'Text' },
      { value: 'Number', name: 'Number' },
      { value: 'Select One', name: 'Select One' },
    ])
      .nullable()
      .optional()
      .describe('Type'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        'Required - The session log cannot be marked complete while this item is empty (opp 8106)',
      ),

    validValues: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Valid Values - Options for Select One activity items'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    activityId: z.number().hidden().describe('Foreign key to Activity'),

    resourceSetId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ResourceSet'),

    activity: belongsTo('Activity'),

    resourceSet: references('ResourceSet'),

    sessionActivityItems: hasMany('SessionActivityItem'),
  })
  .describe('One step of an activity.')
  .as('ActivityItem');

export { activityItem as activityItemSchema };
